<template>
  <div class="user-view">
    <nav-bar>个人中心</nav-bar>
    <div class="box">
      <div class="bg">
        <div class="user-info">
          <img v-if="!user" src="../../assets/img-v2/ic_unlogin_logo.jpg" class="avatar" />
          <img v-else-if="$UserService.isServiceManager()" src="../../assets/img-v2/ic_user_avatar_service.png" class="avatar" />
          <img v-else src="../../assets/img-v2/ic_user_avatar.png" class="avatar" />
          <div class="info">
            <div class="name" v-if="user">{{ userMobile }}</div>
            <div class="name" v-if="!user" @click="onClickLogin">点我登录</div>
            <div class="desc">v{{ require('../../../package.json').version }}</div>
          </div>
        </div>
      </div>
      <div class="menus">
        <template v-for="(menu, index) in menus">
          <div
            v-if="!menu.hidden"
            class="menu-item"
            :key="`menu-${index}`"
            @click="menu.onClick"
          >
            <img :src="menu.icon" class="icon" />
            <div class="label">{{ menu.label }}</div>
            <img src="../../assets/img-v2/ic_user_arrow.png" class="arrow" />
          </div>
        </template>
        <a :href="`tel:${tel}`" v-show="false" ref="tel"></a>
      </div>
      <VanButton
        v-if="user"
        class="logout"
        @click="onClickLogout"
      >
        退出登录
      </VanButton>
    </div>
    <TelephonePopup
      v-model="actionSheetVisible"
      :tels="tels"
      @confirm="onTelSelect"
    />
  </div>
</template>

<script>
import NavBar from '../../components/nav-bar/index'
import TelephonePopup from './components/TelephonePopup.vue';
import { mapGetters } from 'vuex'

let actionSheet

export default {
  name: 'User',
  components: { NavBar, TelephonePopup },
  data() {
    return {
      tel: '',
      tels: [],
      actionSheetVisible: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      enableCall: 'config/enableCall'
    }),
    userMobile() {
      return this.user.mobile
    },
    menus() {
      return [
        {
          icon: require('../../assets/img-v2/ic_user_order.png'),
          label: '订单查询',
          hidden: false,
          onClick: () => {
            this.$OrderService.turnToOrdersView()
          }
        },
        {
          icon: require('../../assets/img-v2/ic_user_coupon.png'),
          label: '我的优惠劵',
          hidden: false,
          onClick: () => {
            if (this.$UserService.isUserLogin()) {
              this.$router.push({ name: 'CouponsView' })
            } else {
              this.$router.push({ name: 'Login' })
            }
          }
        },
        {
          icon: require('../../assets/img-v2/ic_user_feedback.png'),
          label: '意见反馈',
          hidden: false,
          onClick: () => {
            this.$UserService.turnToFeedback()
          }
        },
        {
          icon: require('../../assets/img-v2/ic_user_call.png'),
          label: '一键呼叫',
          hidden: !this.enableCall,
          onClick: () => {
            this.$router.push({ name: 'directCall' })
          }
        },
        {
          icon: require('../../assets/img-v2/ic_user_service.png'),
          label: '客服电话',
          hidden: false,
          onClick: () => {
            this.$UserService
              .fetchCityPhone()
              .then(res => {
                if (!res) {
                  this.$toast('暂无客服电话')
                } else {
                  this.tels = (res || '').split(',').filter(p => !!p) || []
                  console.log('客服电话', this.tels)
                  this.actionSheetVisible = true
                }
              })
              .catch(res => {
                console.log('客服电话 fail', res)
                this.$toast('暂无客服电话')
              })
          }
        }
        // {
        // 	icon: require('../../assets/img/menu-guide.png'),
        // 	label: '用户使用指南',
        //  hidden: false,
        // 	onClick: () => {
        // 		this.$GuideService.turnToUseGuide();
        // 	}
        // }
      ]
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.actionSheetVisible) {
      actionSheet.$el.querySelector('.bottom-cancel').click()
      next(false)
    } else {
      next()
    }
  },
  methods: {
    onClickLogin() {
      this.$UserService.turnToLoginView()
    },
    onClickLogout() {
      this.$UserService
        .logout()
        .then(() => {
          this.$toast({ message: '已退出登录', duration: 2000 })
        })
        .catch(res => {
          this.$toast('退出登录失败' + JSON.stringify(res))
        })
    },
    onTelSelect(key) {
      this.tel = key
      this.$nextTick(() => {
        let ref = this.$refs.tel
        if (ref) {
          ref.click()
        }
      })
      this.actionSheetVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
.user-view {
  background: #F3F4F5;
  min-height: 100vh;
  z-index: 100;
  .box {
    padding: 10px;
  }
  .bg {
    background: #7FB7FF;
    border-radius: 12px;
  }
  .user-info {
    width: 100%;
    height: 120px;
    background: radial-gradient( 0% 120% at 92% 22%, #ADE5FF 0%, #CCE5FF 25%, #7FB7FF 100%);
    border-radius: 12px;
    padding: 0 14px;
    display: flex;
    align-items: center;

    .avatar {
      width: 80px;
      height: 80px;
      margin-right: 20px;
    }

    .info {
      font-family: PingFangSC, PingFang SC;
      color: #000000;
      .name {
        font-weight: 500;
        font-size: 18px;
        line-height: 25px;
      }
      .desc {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        margin-top: 4px;
      }
    }
  }

  .menus {
    margin-top: 10px;
    padding: 0 14px;
    background: #ffffff;
    border-radius: 12px;

    .menu-item {
      height: 52px;
      display: flex;
      align-items: center;

      .icon {
        width: 20px;
        height: 20px;
        margin-right: 12px;
      }

      .label {
        flex: 1;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #000000;
        line-height: 22px;
      }

      .arrow {
        width: 12px;
        height: 12px;
      }
    }
  }

  .logout {
    width: 100%;
    height: 48px;
    margin-top: 10px;
    background: #FFFFFF;
    border-radius: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #FE5959;
    line-height: 22px;
    text-align: center;
    border: none;
  }
}
</style>
